// functions/warehouse_page/product_editor_functions.jsx

// Import API routes
import { deleteProduct } from "../../api/enhancedWarehouse";
import { getSessionUUID } from "../../components/lib/AuthToken";
import logger from "../../utils/logger";

export class ProductEditorFunctions {

    constructor(showAlert) {
        this.showAlert = showAlert;
    }

    async deleteProduct(productId, onSave, product, setLoading, supabase) {
        if (!productId) {
            this.showAlert({
                message: "No product to delete",
                type: "warning",
                buttons: [{ label: "Close", type: "primary" }],
            });
            return;
        }

        setLoading(true);
        try {
            // First check if the product is assigned to any pallets
            logger.log('Checking if product is assigned to any pallets...');
            
            // Query pallet_items to see if this product is used
            const sessionToken = await getSessionUUID();
            const response = await fetch('/enhanced_warehouse/check-product-usage/' + productId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`,
                }
            });
            
            const usageResult = await response.json();
            
            if (!response.ok) {
                throw new Error(usageResult.error || 'Failed to check product usage');
            }
            
            if (usageResult.isInUse) {
                // Product is assigned to pallets, show warning
                this.showAlert({
                    message: `Cannot delete product "${product.product_code}" because it is currently assigned to ${usageResult.palletCount} pallet${usageResult.palletCount > 1 ? 's' : ''}. Please remove it from all pallets first.`,
                    type: "warning",
                    buttons: [{ label: "Close", type: "primary" }],
                });
                return;
            }

            // Product is not in use, show confirmation dialog
            this.showAlert({
                message: `Are you sure you want to delete product "${product.product_code}"? This action cannot be undone.`,
                type: "danger",
                buttons: [
                    { 
                        label: "Cancel", 
                        type: "secondary",
                        onClick: () => {} // Do nothing on cancel
                    },
                    { 
                        label: "Delete Product", 
                        type: "danger",
                        onClick: async () => {
                            setLoading(true);
                            try {
                                const result = await deleteProduct(productId);

                                if (result.success) {
                                    this.showAlert({
                                        message: result.message || 'Product deleted successfully',
                                        type: 'success',
                                        buttons: [{ label: 'Close', type: "primary" }]
                                    });

                                    // Close the editor and trigger refresh
                                    onSave();
                                } else {
                                    throw new Error(result.message || 'Failed to delete product');
                                }
                            } catch (error) {
                                logger.error('Error deleting product:', error);
                                this.showAlert({
                                    message: `Failed to delete product: ${error.message}`,
                                    type: 'danger',
                                    buttons: [{ label: 'Close', type: "primary" }]
                                });
                            } finally {
                                setLoading(false);
                            }
                        }
                    }
                ]
            });

        } catch (error) {
            logger.error('Error checking product usage:', error);
            this.showAlert({
                message: `Failed to check product usage: ${error.message}`,
                type: 'danger',
                buttons: [{ label: 'Close', type: "primary" }]
            });
        } finally {
            setLoading(false);
        }
    }
}
